import { useMemo } from 'react';

import type { IncidentType, LocalizedString } from '@/types';

export const useFilteredIncidents = (
  incidents: IncidentType[],
  searchKey: string,
  incidentLang: keyof LocalizedString
): IncidentType[] => {
  return useMemo(() => {
    if (!searchKey.trim()) {
      return incidents;
    }

    const lowerKey = searchKey.toLowerCase();

    return incidents.filter((inc) => {
      const text = inc.headerText?.[incidentLang] ?? '';

      return text.toLowerCase().includes(lowerKey);
    });
  }, [incidents, searchKey, incidentLang]);
};
